import { ORDER_CONST } from './OrderWrapper.d';
import { Order } from './OrderWrapper.styles';
import type { OrderWrapperProps } from './OrderWrapper.d';

export const OrderSuccessWrapper = ({ children }: OrderWrapperProps) => (
  <Order.Container data-testid={ORDER_CONST.TEST_ID} size="1/2">
    {children}
  </Order.Container>
);

export default OrderSuccessWrapper;
